import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { X } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full px-6 py-16 md:py-20 bg-blush/30" data-id="element-151">
      <div className="max-w-5xl mx-auto" data-id="element-152">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20" data-id="element-153">
          {/* Left Column: The Problem Statement */}
          <div className="lg:col-span-7" data-id="element-154">
            <FadeIn data-id="element-155">
              <h2 className="text-4xl md:text-5xl mb-8 leading-tight text-charcoal" data-id="element-156">
                Si te portas bien todo el día… <br data-id="element-157" />
                <span className="text-rose italic font-serif" data-id="element-158">
                  y en la noche te "pierdes"
                </span>
              </h2>
              <div className="h-px w-32 bg-charcoal/20 mb-10" data-id="element-159"></div>
            </FadeIn>

            <div className="space-y-8 text-lg md:text-xl text-body font-light mb-16" data-id="element-160">
              <FadeIn data-id="element-161">
                <p data-id="element-162">
                  Esto no va sobre "comer limpio". Ni sobre contar calorías. Ni
                  sobre vivir en modo castigo.
                </p>
                <p data-id="element-163">Va sobre algo más específico y más real:</p>
                <p className="font-medium text-charcoal font-serif text-2xl italic" data-id="element-164">
                  El antojo nocturno que te rompe la semana y la hinchazón que
                  te hace sentir pesada incluso cuando "no comiste tanto".
                </p>
              </FadeIn>

              <FadeIn delay={0.2} data-id="element-165">
                <p className="mt-12 mb-6 text-sm uppercase tracking-widest text-muted" data-id="element-166">
                  Intentos fallidos
                </p>
                <ul className="flex flex-wrap gap-x-8 gap-y-4" data-id="element-167">
                  {['Comer menos', 'Quitar carbs', 'Empezar el lunes', 'Ser fuerte', 'Tomar agua'].map((item, i) => <li key={i} className="flex items-center gap-2 text-muted group" data-id="element-168">
                      <span className="line-through decoration-rose/50 decoration-1" data-id="element-169">
                        {item}
                      </span>
                      <X className="w-3 h-3 text-rose opacity-60" data-id="element-170" />
                    </li>)}
                </ul>
                <p className="mt-10 font-medium text-charcoal" data-id="element-171">
                  Y aún así… la noche llega y se repite la misma escena.
                </p>
              </FadeIn>
            </div>
          </div>

          {/* Right Column: The Insight Card */}
          <div className="lg:col-span-5 lg:pt-20" data-id="element-172">
            <FadeIn delay={0.3} data-id="element-173">
              <div className="bg-charcoal text-linen p-10 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-174">
                <div className="absolute top-0 right-0 w-32 h-32 bg-rose/10 rounded-full blur-3xl -mr-16 -mt-16" data-id="element-175"></div>

                <h3 className="text-2xl font-serif italic mb-8 text-white border-b border-white/10 pb-4" data-id="element-176">
                  La escena que nadie pone en Instagram
                </h3>

                <div className="space-y-6 font-light text-linen/80 leading-relaxed" data-id="element-177">
                  <p data-id="element-178">No es el hambre normal.</p>
                  <p data-id="element-179">
                    Es una urgencia. Es tu cuerpo pidiendo rápido. Tu mente
                    buscando alivio. Tu cansancio ganando.
                  </p>
                  <p data-id="element-180">
                    Y después… la culpa. La negociación. El "mañana me porto
                    mejor".
                  </p>
                </div>

                <div className="mt-10 pt-8 border-t border-white/10" data-id="element-181">
                  <p className="font-serif text-xl text-white leading-snug" data-id="element-182">
                    Ese ciclo no se rompe con motivación. Se rompe con un
                    sistema que no dependa de tu fuerza de voluntad a las 9PM.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}